/**
 * <strong>Purpose:</strong> <br>
 * Provides a "watch"-like behavior for the setter of "text".<br>
 * The size setter must also be triggered when the text is changed.<br>
 *
 * <strong>Contract:</strong> <br>
 * This mixin is dependent upon: <br>
 * {@link module:mw-form/mixins/property/TextMixin}<br>
 * {@link module:mw-form/mixins/property/SizeMixin}<br>
 * {@link module:mw-form/mixins/property/DropDownButtonSizeMixin}<br>
 *
 * @module mw-form/mixins/property/DropDownButtonTextMixin
 *
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
        "dojo/_base/declare",
        "dojo/dom-construct",
        "mw-form/mixins/property/TextMixin",
        "mw-form/mixins/property/SizeMixin",
        "mw-form/mixins/property/DropDownButtonSizeMixin"
    ],
    function (declare, domConstruct, TextMixin, SizeMixin, DropDownButtonSizeMixin) {

        var DropDownButtonTextMixin = declare(null, {

            _updateTextInDOM: function (text) {
                this.inherited(arguments);
                this._placeTextAndResize(text);
            },

            // Separated primarily for testing
            _placeTextAndResize: function (text) {
                var peerObj = this._getPeerAndPosition();

                domConstruct.place(this.textNode, peerObj.peer, peerObj.position); // Move the textNode based on state
                this._placeTextInNode(text, this.lastTextLineNode); // Place appropriate text in lastTextLineNode

                this.set("width", this.get("width"));
                this.set("height", this.get("height"));
            },

            _getPeerAndPosition: function () {
                var peerObj = {};

                if (this._isInline()) {
                    peerObj.peer = this.arrowNode;
                    peerObj.position = "before";
                } else {
                    peerObj.peer = this.iconNode;
                    peerObj.position = "after";
                }

                return peerObj;
            },

            _getSplitTextAtLastNewLineCharacter: function (text) {
                var textObj = {};

                // Split text as needed if arrow mode is inline
                if (this._isInline()) {
                    // Split text into multiple lines
                    var lastNewlineIndex = text.lastIndexOf("\n");

                    // Text has a newline character
                    if (lastNewlineIndex >= 0) {
                        // Split text at last newline if arrow mode is "inline" and
                        // set the text contents of the lastNewLine node to be the
                        // text following the last newline character.
                        textObj.mainText = text.substring(0, lastNewlineIndex);
                        textObj.lastTextLine = text.substring(lastNewlineIndex+1, text.length);
                    } else { // Text does not have a newline character
                        if (this.get("iconAlignment") === "left") {
                            // Horizontal, Inline, and single line of text
                            textObj.mainText = ""; // Adds mwEmptyNode class to node
                            textObj.lastTextLine = text;
                        } else {
                            // Vertical, Inline, and single line of text
                            textObj.mainText = text;
                            textObj.lastTextLine = ""; // Adds mwEmptyNode class to node
                        }
                    }
                } else {
                    textObj.mainText = text;
                    textObj.lastTextLine = "";
                }

                return textObj;
            },

            _isInline: function () {
                return ((this.get("arrowMode") === "inline") ||
                    ((this.get("arrowMode") === "auto") &&
                        (this.get("iconAlignment") === "top")));
            },

            _getTextForDOM: function (text, node) {
                text = this.inherited(arguments);

                var textObj = this._getSplitTextAtLastNewLineCharacter(text);

                if (node === this.textNode) {
                    return textObj.mainText;
                } else if (node === this.lastTextLineNode) {
                    return textObj.lastTextLine;
                } else {
                    return text;
                }
            }

        });

        DropDownButtonTextMixin._dependencies = [
            {mixin: TextMixin, orderDependent: true},
            {mixin: SizeMixin, orderDependent: false},
            {mixin: DropDownButtonSizeMixin, orderDependent: false}
        ];

        return DropDownButtonTextMixin;
    });